import type { EditImportPreviewEntryInput, ImportPreviewEntry } from '@taler/api-client'
import { formatLocalDate, isZeroMoney, type Money, parseLocalDate } from '@taler/domain'

export interface ImportRowDraft {
  entryDateText: string
  descriptionText: string
  amount: Money | null
  counterAccountId: string | undefined
  excluded: boolean
}

export function draftFromEntry(entry: ImportPreviewEntry): ImportRowDraft {
  return {
    entryDateText: formatLocalDate(entry.entryDate),
    descriptionText: entry.description,
    amount: entry.amount,
    counterAccountId: entry.counterAccountId,
    excluded: entry.excluded,
  }
}

/** `undefined` while the draft does not yet parse into a postable edit - the row's own save
 * button stays disabled rather than sending a request the server would 422. */
export function draftToInput(draft: ImportRowDraft): EditImportPreviewEntryInput | undefined {
  const description = draft.descriptionText.trim()
  if (draft.entryDateText === '' || description === '' || draft.amount === null) return undefined
  if (isZeroMoney(draft.amount)) return undefined
  return {
    entryDate: parseLocalDate(draft.entryDateText),
    counterAccountId: draft.counterAccountId,
    amount: draft.amount,
    description,
    excluded: draft.excluded,
  }
}
